import React, { useRef } from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../assests/brand/brand2.png";
import { singleTransactionTxn } from "../api/remitterApi";
import { useState } from "react";
import { useEffect } from "react";
import StatusBadge from "./listing/StatusBadge";

const TransactionReceiptModal = ({ open, onClose, txnId }) => {

  const [txn, setTxn] = useState(null);

  useEffect(() => {
   
    if (txnId) loadTxn();
  }, [txnId]);

  const loadTxn = async () => {
    const res = await singleTransactionTxn(txnId);
    if (res.success)
         setTxn(res.data);
  };

  const pdfRef = useRef();

  // ===== PDF DOWNLOAD =====
  const downloadPDF = async () => {
    const canvas = await html2canvas(pdfRef.current, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(`txn_${txn?.txnId}.pdf`);
  };

  // ===== PRINT =====
  const printReceipt = () => {
    const html = pdfRef.current.outerHTML;
    const win = window.open("", "", "width=420,height=700");

    win.document.write(`
      <html>
      <head>
        <title>Receipt</title>
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap" rel="stylesheet">
        <style>
          body { font-family: Poppins; margin:0; padding:0; }
          .receipt {
            width: 100%;
            max-width: 420px;
            margin: auto;
            padding: 12px;
            border: 1px dashed #888;
          }
          .logo img { width: 90px; display:block; margin:auto; }
          h2 { text-align:center; font-size:15px; margin:5px 0; }
          .row { display:flex; justify-content:space-between; font-size:12px; margin:3px 0; }
          .footer { text-align:center; font-size:10px; margin-top:8px; }
        </style>
      </head>
      <body>
        ${html}
        <script>
          window.onload = function() { window.print(); };
        </script>
      </body>
      </html>
    `);

    win.document.close();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"   // ✅ desktop wide
    >
      <DialogContent className="!p-0">

        {/* POPUP CARD */}
        <div
          ref={pdfRef}
          className="receipt border-gray-100 p-4 md:p-6  shadow-xl border"
          style={{ fontFamily: "Poppins" }}
        >
          {/* LOGO */}
          <div className="logo text-center mb-2">
            <img src={logo} alt="logo" className="mx-auto w-[80px] md:w-[100px]" />
          </div>

          <h2 className="text-center font-bold text-green-600 text-lg">
            Transaction Receipt
          </h2>

          <div className="mt-3 space-y-1 text-sm">
            <div className="flex justify-between"><b>Txn ID</b><span>{txn?.txnId}</span></div>
            <div className="flex justify-between"><b>UTR</b><span>{txn?.utr || "-"}</span></div>
            <div className="flex justify-between"><b>ACK No</b><span>{txn?.settlementResponse?.ackno || "-"}</span></div>
            <div className="flex justify-between"><b>Amount</b><span>₹ {txn?.amount}</span></div>
            <div className="flex justify-between"><b>Account</b><span>XXXXXX{txn?.accountNumber?.slice(-4)}</span></div>
            <div className="flex justify-between"><b>IFSC</b><span>{txn?.ifsc}</span></div>
            <div className="flex justify-between items-center gap-2">
              <b>Status</b>
              <StatusBadge status={txn?.transactionStatus} />
            </div>
            <div className="flex justify-between"><b>Date</b><span>{new Date(txn?.createdAt).toLocaleString()}</span></div>
          </div>

          <p className="text-xs text-center mt-2">
            This is a system generated receipt. No signature required.
          </p>
        </div>

        {/* BUTTONS */}
        <div className="p-3 flex flex-col sm:flex-row gap-2 bg-gray-50">
          <Button
            fullWidth
            startIcon={<DownloadIcon />}
            onClick={downloadPDF}
            className="!bg-green-500 !text-white"
          >
            Download
          </Button>

          <Button
            fullWidth
            startIcon={<PrintIcon />}
            onClick={printReceipt}
            className="!bg-blue-500 !text-white"
          >
            Print
          </Button>

          <Button
            fullWidth
            startIcon={<CloseIcon />}
            onClick={onClose}
            className="!bg-gray-200 !text-black"
          >
            Close
          </Button>
        </div>

      </DialogContent>
    </Dialog>
  );
};

export default TransactionReceiptModal;
